import React, { useEffect, useState } from "react";
import { Button, Input, Select } from "../ui";
import NovoEventoService from "../../services/Eventos/NovoEventoService";
import InscricaoService from "../../services/Inscricoes/InscricaoService";
import { Send } from "lucide-react";
import { StravaIcon } from "../strava/StravaConnectButton";
import StravaImportModal from "../strava/StravaImportModal";

function NovaMetricaCorredor({ idCorrida, onSuccess, onError }) {
  const [showStravaModal, setShowStravaModal] = useState(false);
  const [categorias, setCategorias] = useState([]);
  const [categoria, setCategoria] = useState("");
  const [posicaoGeral, setPosGeral] = useState("");
  const [posCategoria, setPosCategoria] = useState("");
  const [tempooficial, setTempooficial] = useState("");
  const [tempoBruto, setTempoBruto] = useState("");
  const [ritmo, setRitmo] = useState("");
  const [kmh, setkmh] = useState("");
  const [horaPartida, setHoraPartida] = useState("");
  const [loading, setLoading] = useState(false);

  const novoEvento = new NovoEventoService();
  const inscricaoService = new InscricaoService();

  useEffect(() => {
    const getCategorias = async () => {
      try {
        const response = await novoEvento.geCategoriaPorCorrida(idCorrida);
        if (!response.ok) {
          throw new Error(`Erro de HTTP: ${response.status}`);
        }
        const dat = await response.json();
        setCategorias(dat);
      } catch (err) {
        console.log(err);
      }
    };
    if (idCorrida) {
      getCategorias();
    }
  }, [idCorrida]);

  async function handleSubmit(e) {
    if (e) e.preventDefault();
    setLoading(true);

    const dat = {
      id_usuario: sessionStorage.getItem("brv-user-id"),
      id_corrida: idCorrida,
      id_categoria_corrida: categoria ? parseInt(categoria) : null,
      posicao_geral: posicaoGeral ? parseInt(posicaoGeral) : null,
      posicao_categoria: posCategoria ? parseInt(posCategoria) : null,
      tempo_oficial: tempooficial || null,
      tempo_bruto: tempoBruto || null,
      ritmo: ritmo || null,
      kmh: kmh ? parseFloat(kmh) : null,
      hora_partida: horaPartida || null,
    };

    try {
      const response = await inscricaoService.setMetricaCorredoro(
        JSON.stringify(dat)
      );
      let res = null;
      if (response.ok) {
        try {
          res = await response.json();
        } catch (e) {
          res = { success: true };
        }
        if (onSuccess) onSuccess(res);
      } else {
        if (onError) onError(response);
      }
    } catch (err) {
      console.log(err);
      if (onError) onError(err);
    } finally {
      setLoading(false);
    }
  }

  const categoriaOptions = categorias.map((c) => ({
    label: c.categoria || c.nome || String(c.id),
    value: String(c.id),
  }));

  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4 text-left">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-1 border-b border-urb-border/50">
          <h3 className="text-base font-bold text-white m-0">
            Registrar Métricas da Prova
          </h3>
          <button
            type="button"
            onClick={() => setShowStravaModal(true)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-[#FC4C02]/15 text-[#FC4C02] hover:bg-[#FC4C02]/25 border border-[#FC4C02]/30 text-xs font-bold transition-all cursor-pointer w-fit"
          >
            <StravaIcon className="w-3.5 h-3.5" />
            <span>Importar do Strava</span>
          </button>
        </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Posição Geral
          </label>
          <Input
            value={posicaoGeral}
            onChange={(e) => setPosGeral(e.target.value.replace(/\D/g, ""))}
            placeholder="Ex: 42"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Categoria
          </label>
          <Select
            value={categoria}
            onChange={(e) => setCategoria(e.target.value)}
            options={categoriaOptions}
            placeholder="Selecione a categoria"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Posição Categoria
          </label>
          <Input
            value={posCategoria}
            onChange={(e) => setPosCategoria(e.target.value.replace(/\D/g, ""))}
            placeholder="Ex: 5"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Tempo Oficial (HH:MM:SS)
          </label>
          <Input
            value={tempooficial}
            onChange={(e) => setTempooficial(e.target.value)}
            placeholder="00:45:30"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Tempo Bruto (HH:MM:SS)
          </label>
          <Input
            value={tempoBruto}
            onChange={(e) => setTempoBruto(e.target.value)}
            placeholder="00:46:12"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Hora da Partida (HH:MM:SS)
          </label>
          <Input
            value={horaPartida}
            onChange={(e) => setHoraPartida(e.target.value)}
            placeholder="07:00:00"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Ritmo / Pace (MM:SS)
          </label>
          <Input
            value={ritmo}
            onChange={(e) => setRitmo(e.target.value)}
            placeholder="04:30"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-xs font-semibold text-slate-300">
            Velocidade Média (Km/h)
          </label>
          <Input
            type="number"
            step="0.1"
            value={kmh}
            onChange={(e) => setkmh(e.target.value)}
            placeholder="13.2"
          />
        </div>
      </div>

      <div className="flex justify-end pt-3 border-t border-urb-border">
        <Button
          type="submit"
          variant="primary"
          size="md"
          loading={loading}
          disabled={loading}
          className="font-bold flex items-center gap-2"
        >
          <Send className="w-4 h-4" />
          Enviar Métricas
        </Button>
      </div>
    </form>

    <StravaImportModal
      isOpen={showStravaModal}
      onClose={() => setShowStravaModal(false)}
      idCorrida={idCorrida}
      idCategoriaCorrida={categoria}
      onSuccess={(res) => {
        setShowStravaModal(false);
        if (onSuccess) onSuccess(res);
      }}
      onError={onError}
    />
  </>
  );
}

export default NovaMetricaCorredor;
